import { Breadcrumb } from 'antd'
import { Link, useMatch } from 'react-router'
import { routes } from 'app/routes'

type BreadcrumbItem = { title: React.ReactNode }

const invoicesListCrumb: BreadcrumbItem = {
  title: <Link to={routes.invoices.list}>Invoices</Link>,
}

const AppBreadcrumb = () => {
  const newMatch = useMatch(routes.invoices.new)
  const editMatch = useMatch(routes.invoices.patterns.edit)
  const showMatch = useMatch(routes.invoices.patterns.show)

  let items: BreadcrumbItem[]
  if (newMatch) {
    items = [invoicesListCrumb, { title: 'New Invoice' }]
  } else if (editMatch) {
    const id = editMatch.params.id!
    items = [
      invoicesListCrumb,
      { title: <Link to={routes.invoices.show(id)}>Invoice #{id}</Link> },
      { title: 'Edit' },
    ]
  } else if (showMatch) {
    items = [invoicesListCrumb, { title: `Invoice #${showMatch.params.id}` }]
  } else {
    items = [{ title: 'Invoices' }]
  }

  return <Breadcrumb items={items} className="pt-3 pb-2" />
}

export default AppBreadcrumb
